import React from 'react';
import { Text } from '@radix-ui/themes';
import caseStudy from "../../../assets/images/caseStudy.png";

const CsWait: React.FC = () => {
  return (
    <div className="flex flex-1 flex-col items-center justify-center">
      <img
        src={caseStudy}
        alt="Case Study"
        className="h-[20vh] w-[35vw] object-contain"
      />
      <Text className="text-white py-4 text-center font-[Lato-Regular] text-base w-[60vw] mb-4">
        Trainer would like you to volunteer for group presentations<br />Group Leaders to volunteer NOW
      </Text>
    </div>
  );
};

export default CsWait;